<template>
  <div style="padding: 0 40px;">
    <Loading ref="loading" minHeight="40vh">
      <BadgeList v-if="badgeProjectList.length" :badgeProjectList="badgeProjectList" :showDisplaySwitch="false" />
      <h5 v-else style="margin-top: 1rem; margin-bottom: 1rem">公開バッジはありません</h5>
    </Loading>
  </div>
</template>
<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import RootVue from "@/RootVue.vue";
import BadgeProjectResp from '@/interface/api/BadgeProjectResp';
import Loading from "@/component/Loading.vue"
import { Ref } from 'vue-property-decorator';
import BadgeList from "@/component/parts/BadgeList.vue";
@Options({
  components:{
    Loading,
    BadgeList,
  },
  props:{
    userName:{
      type:String,
    }
  }
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;
  //mounted前のlifesycleだと初期化されていないので使用できない点に注意
  @Ref() readonly loading = null as any as Loading;

  readonly userName!:string;
  badgeProjectList = [] as BadgeProjectResp[];

  async created() {
    try {
      this.loading?.start()
      let res = await this.$root.restAccess.getPublicBadge(this.userName);
      if(res.ok){
        this.badgeProjectList = await res.json();
      }
    } catch (e) {
      console.error(e);
    }
    this.loading?.finish()
  }
}
</script>